import {push} from 'connected-react-router';

import {actionTypes} from '../components/Lesson/SlideshowCanvas/reducerState';
import useUndoReducer from '../components/Lesson/SlideshowCanvas/useReducerUndo';
import {COMMAND_PALETTE_NEW_ACTIVITY} from '../state/commandPalette/commandPaletteActionTypes';

export const LOCKED_SLIDE_TYPES = ['intro', 'learningOutcomes', 'end'];

const isMac = navigator.platform.indexOf('Mac') === 0;
export const defaultModifierKey = isMac ? 'cmd' : 'ctrl';
const secondaryModifierKey = isMac ? 'option' : 'alt';

export const getGlobalHotKeys = (dispatch) => [
  {
    id: 'GoToHome',
    title: 'Go to Home',
    hotkey: `${secondaryModifierKey}+h`,
    section: 'Navigation',
    handler: () => {
      dispatch(push('/'));
    },
  },
  {
    id: 'GoToLearning',
    title: 'Go to Learning',
    hotkey: `${secondaryModifierKey}+l`,
    section: 'Navigation',
    keywords: 'course',
    handler: () => {
      dispatch(push('/learning'));
    },
  },
  {
    id: 'GoToPeople',
    title: 'Go to People',
    hotkey: `${secondaryModifierKey}+p`,
    section: 'Navigation',
    handler: () => {
      dispatch(push('/people'));
    },
  },
  {
    id: 'GoToSurveys',
    title: 'Go to Surveys',
    hotkey: `${secondaryModifierKey}+s`,
    section: 'Navigation',
    handler: () => {
      dispatch(push('/surveys'));
    },
  },
  {
    id: 'GoToReports',
    title: 'Go to Reports',
    hotkey: `${secondaryModifierKey}+r`,
    section: 'Navigation',
    handler: () => {
      dispatch(push('/reports'));
    },
  },
];

export const getCourseHotkeys = (dispatch) => [
  {
    id: 'AddActivity',
    title: 'Add an activity',
    hotkey: `${defaultModifierKey}+m`,
    section: 'Content creation',
    handler: () => {
      dispatch({type: COMMAND_PALETTE_NEW_ACTIVITY});
    },
  },
];

export const getSlideshowCanvasHotkeys = (dispatch) => [
  {
    id: 'duplicate-slide',
    title: 'Duplicate Slide',
    hotkey: `${defaultModifierKey}+d`,
    handler: () => {
      dispatch({type: actionTypes.DUPLICATE_SLIDE});
    },
  },
  {
    id: 'delete-slide',
    title: 'Delete Slide',
    hotkey: `${defaultModifierKey}+backspace`,
    handler: () => {
      dispatch({type: actionTypes.DELETE_SLIDE});
    },
  },
  {
    id: 'lesson-undo',
    title: 'Undo',
    hotkey: `${defaultModifierKey}+z`,
    handler: () => dispatch({type: useUndoReducer.types.undo}),
  },
  {
    id: 'lesson-redo',
    title: 'Redo',
    hotkey: `${defaultModifierKey}+shift+z,${defaultModifierKey}+y`,
    handler: () => dispatch({type: useUndoReducer.types.redo}),
  },
  {
    id: 'lesson-next',
    title: 'Next',
    hotkey: 'right,down',
    handler: () => dispatch({type: actionTypes.MOVE_TO_NEXT_SLIDE_ELEMENT}),
  },
  {
    id: 'lesson-previous',
    title: 'Previous',
    hotkey: 'left,up',
    handler: () => dispatch({type: actionTypes.MOVE_TO_PREVIOUS_SLIDE_ELEMENT}),
  },
];
